import React from 'react'

export function EmptyPage({ action }) {
  return (
    <div
      className='column column-center'
      style={{
        justifyContent: 'center',
        height: 'calc(100vh - 300px)'
      }}
    >
      <div
        style={{
          width: 760,
          border: '1px solid #DBDBE6',
          borderRadius: '16px',
          background: '#fff'
        }}
        className='row row-center'
      >
        <div
          className='column'
          style={{
            padding: 40,
            alignItems: 'flex-start'
          }}
        >
          <p
            style={{
              fontWeight: 600,
              fontSize: 20,
              lineHeight: '130%',
              marginBottom: 16
            }}
          >
            Boost Your Team’s Cybersecurity Awareness
          </p>
          <p
            style={{
              marginBottom: 32
            }}
          >
            Deliver engaging, bite-sized security training to your employees. Cyberlift’s training topics help your team
            stay prepared against cyber threats with quick, effective lessons. Invite your employees and launch their
            first training in minutes.
          </p>
          {action}
        </div>
        <img src='images/tp-empty-page-img.png' style={{ width: 360 }} alt='' />
      </div>
    </div>
  )
}
